module.exports = __webpack_public_path__ + "static/media/althar-credentials.f12954a4.mp4";